<ng-template #createModal let-modal>
  <form #f="ngForm" (ngSubmit)="f.form.valid && modal.close(roleModel)">
    <div class="modal-header justify-content-center">
      <h4 *ngIf="roleModelAction === 'update'" class="title">Edit Role</h4>
      <h4 *ngIf="roleModelAction === 'create'" class="title">Create Role</h4>
    </div>
    <div class="modal-body">
      <label>Name</label>
      <div class="form-group mb-3">
        <input
          [disabled]="roleModelAction === 'update'"
          type="text"
          #name="ngModel"
          [ngClass]="{ 'is-invalid': name.invalid}"
          [(ngModel)]="roleModel.name"
          name="name"
          class="form-control"
          required
        />
      </div>
      <label>Description</label>
      <div class="form-group">
        <input
          type="text"
          #description="ngModel"
          [ngClass]="{ 'is-invalid': f.submitted && description.invalid }"
          [(ngModel)]="roleModel.description"
          name="description"
          class="form-control"
        />
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="modal.dismiss('cancel')">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="name.invalid">Submit</button>
    </div>
  </form>
</ng-template>

<ng-template #usersModal let-modal>
  <div class="modal-header justify-content-center">
    <h4 class="title title-up">Registered users with role <b>{{ roleModel.name }}</b></h4>
  </div>
  <div class="modal-body fit-height">
    <ul class="list-group">
      <li *ngFor="let user of roleModel.users" class="list-group-item">{{ user }}</li>
    </ul>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm mx-3 btn-primary" (click)="modal.close()">Close</button>
  </div>
</ng-template>

<div class="main-content">
  <div class="container-fluid mt-4">
    <div class="card">
      <div class="card-header">
        <h3>
          Roles
          <span class="btn-wrapper">
            <button type="button" class="btn btn-success btn-sm me-1">
              <fa-icon [icon]="['fal','sync']" (click)="reload()"></fa-icon>
            </button>
          </span>
          <span class="btn-wrapper" placement="top" [ngbTooltip]="canEdit? '':'Insufficent permission'" container="body">
            <button [disabled]="!canEdit" type="button" class="btn btn-primary btn-sm" (click)="openCreate(createModal)">
              <fa-icon [icon]="['fal','plus']"></fa-icon> Create Role
            </button>
          </span>
        </h3>
        <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="user-graduate" size="lg" [fixedWidth]="true"></fa-icon>
      </div>
      <div *ngIf="!roles" class="card-body">Loading...</div>
      <div *ngIf="roles" class="card-body">
        <table class="table table-hover">
          <thead class="text-primary">
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Users</th>
              <th>Created</th>
              <th class="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row" *ngFor="let r of roles">
              <td>{{ r.name }}</td>
              <td>{{ r.description }}</td>
              <td>
                <span *ngIf="userPermission">{{ r.users?.length }}</span>
                <fa-icon
                  *ngIf="!userPermission"
                  [fixedWidth]="true"
                  [icon]="['fal', 'exclamation-triangle']"
                  ngbTooltip="Insufficent permission"
                  placement="left"
                ></fa-icon>
              </td>
              <td>{{ r.created | date:dateFormat }}</td>
              <td class="text-right">
                <span class="btn-wrapper" [ngbTooltip]="userPermission ? null : 'Insufficent permission'" placement="left">
                  <button
                    type="button"
                    class="btn btn-light btn-sm me-1"
                    (click)="showUsers(r)"
                    [disabled]="!userPermission || !r.users?.length"
                    ngbTooltip="Show all users with this role"
                    placement="left"
                  >
                    <fa-icon [fixedWidth]="true" [icon]="['fal','users']"></fa-icon>
                  </button>
                </span>
                <span class="btn-wrapper" [ngbTooltip]="canEdit ? null : 'Insufficent permission'" placement="left">
                  <button
                    type="button"
                    class="btn btn-light btn-sm me-1"
                    (click)="openUpdate(createModal, r)"
                    [disabled]="!canEdit"
                    ngbTooltip="Edit role"
                    placement="left"
                  >
                    <fa-icon [fixedWidth]="true" [icon]="['fal','cog']"></fa-icon>
                  </button>
                </span>
                <span class="btn-wrapper" placement="top" [ngbTooltip]="canDelete ? null : 'Insufficent permission'" placement="left">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    placement="right"
                    (click)="openDelete(r.name)"
                    [disabled]="!canDelete"
                    ngbTooltip="Delete role"
                    placement="left"
                  >
                    <fa-icon [fixedWidth]="true" [icon]="['fal','trash']"></fa-icon>
                  </button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
